import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';
import _ from 'lodash';

import { SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components/';
import { SIMPLE_AVERAGE_FORM_NAME } from 'Common/FormEnum';
import { SimpleAverageFieldEnum as Fields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  rangeDateValidator,
  makeSelectFieldOptionsFromEnum,
  makeOptionsDataWithAll,
  makeOptionsData,
} from 'Common/FormHelper';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { RangeDatePickerField } from 'Common/SemanticWrapper';
import { SiteSelectField } from 'Common/ReduxFormFields';

const mealTypeOptions = makeSelectFieldOptionsFromEnum(MenuMealTypesEnum);

const SimpleAverageFormContainer = (props) => {
  const { cycleMenus, loading, reportFetching, selectedSite } = props;

  return (
    <Form name="SimpleAverage">
      <TitledCard title={'Report Parameters'}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <RangeDatePickerField
                fromName={Fields.FromDate}
                toName={Fields.ToDate}
                disabled={loading || reportFetching}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                name={Fields.Site}
                component={SiteSelectField}
                loading={loading || reportFetching}
                disabled={loading || reportFetching}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label={'Meal Type'}
                name={Fields.MealType}
                component={SelectField}
                options={mealTypeOptions}
                loading={loading || reportFetching}
                disabled={loading || reportFetching}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label={'Cycle Menu'}
                name={Fields.CycleMenu}
                component={SelectField}
                options={
                  cycleMenus.length > 1 || cycleMenus.length === 0
                    ? makeOptionsDataWithAll(cycleMenus)
                    : makeOptionsData(cycleMenus)
                }
                loading={loading || reportFetching}
                disabled={loading || reportFetching}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4} style={{ paddingTop: 25 }}>
              <Field
                label={'Reimbursable Items Only'}
                name={Fields.ReimbursableItemsOnly}
                component={CheckboxField}
                disabled={loading || reportFetching}
              />
            </Grid.Column>
            <Grid.Column width={4} style={{ paddingLeft: 0, paddingTop: 25 }}>
              <Field
                label={'Include Allergy Report'}
                name={Fields.IncludeAllergyReport}
                component={CheckboxField}
                disabled={loading || reportFetching || selectedSite === 'ALL'}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  if (_.isNil(values[Fields.CycleMenu])) {
    errors[Fields.CycleMenu] = 'Cycle Menu must be selected';
  }

  if (_.isNil(values[Fields.Site])) {
    errors[Fields.Site] = 'Site must be selected';
  }

  const rangeErrors = rangeDateValidator(
    values[Fields.FromDate],
    values[Fields.ToDate],
    {
      granularity: 'day',
      fromName: Fields.FromDate,
      toName: Fields.ToDate,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
    }
  );

  return { ...errors, ...rangeErrors };
};

export const SimpleAverageForm = reduxForm({
  form: SIMPLE_AVERAGE_FORM_NAME,
  validate,
  enableReinitialize: false,
  destroyOnUnmount: false,
})(SimpleAverageFormContainer);



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/components/SimpleAverageForm.js